<script setup lang="ts">
import { profileMenuSection } from '~/utils/menuSectionsUtils'
const authStore = useAuthStore()
const { t } = useLocale()
const { personalDataRoute } = useMcdRoutes()
const { trackProfileMenuClick } = useGTM()

const emit = defineEmits(['overlay-closed'])

const logout = () => {
  authStore.removeToken()
  emit('overlay-closed')
}

const onRouteClick = (menuItem: string) => {
  trackProfileMenuClick(menuItem)
  emit('overlay-closed')
}
</script>

<template>
  <header class="mb-8 flex w-full p-2">
    <CloseIcon width="14.5" height="14.5" @click="emit('overlay-closed')" />
  </header>
  <main class="p-2">
    <header class="mb-8 text-xl font-bold">{{ t('profile.title') }}</header>
    <div class="mb-8 rounded-md">
      <NuxtLink :to="personalDataRoute()" @click="emit('overlay-closed')">
        <UserQRCard />
      </NuxtLink>
    </div>
    <section class="flex flex-col gap-5">
      <div v-for="section in profileMenuSection()" :key="section.key">
        <NuxtLink
          :data-test="`${section.key}-link`"
          :to="section.url"
          @click="onRouteClick(section.key)"
        >
          <section class="mb-2 flex w-full items-center gap-5">
            <figure>
              <img class="h-full w-6" :src="section.icon" :alt="section.title" />
            </figure>
            <h4 class="text-sm">{{ section.title }}</h4>
          </section>
        </NuxtLink>
      </div>
    </section>
  </main>
  <footer class="mt-10 p-2">
    <button class="flex w-full items-center gap-5" data-test="logout-button" @click="logout">
      <figure>
        <img class="h-full w-6" src="/images/icons/profileSections/logout.svg" alt="Logout" />
      </figure>
      <h4 class="text-sm">{{ t('profile.sections.logout') }}</h4>
    </button>
  </footer>
</template>
